import React, { useState } from "react";
import GlobalWrapper from "../../../../components/Wrapper/GlobalWrapper";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

const TestCourse = ({ data, setOptionTermId, id }) => {
  console.log(data);

  const [check, setCheck] = useState(false);

  const TblData = data?.map((list, index) => ({
    ...list,
    serialNumber: index + 1,
    term: `Term ${index + 1}`,
  }));

  return (
    <Box>
      <Button
        sx={{
          color: "white",
          background: `linear-gradient(to bottom, #0089d0 0%, #0089d0 10%, #a125c2 100%)`,
          borderRadius: 4,
          m: 1,
        }}
        size="small"
        onClick={() => {
          setCheck(true);
          setOptionTermId(id);
        }}
      >
        Check Terms
      </Button>

      {check ? (
        <GlobalWrapper>
          <Box
            sx={{
              width: "100%",
              p: 1,
            }}
          >
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>serialNumber</TableCell>
                    <TableCell align="right">Terms</TableCell>
                    <TableCell align="right">InrTerm</TableCell>
                    <TableCell align="right">AedTerm</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {TblData?.map((row) => (
                    <TableRow
                      key={row.serialNumber}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {row.serialNumber}
                      </TableCell>
                      <TableCell align="right">{row.term}</TableCell>
                      <TableCell align="right">{row.InrTerm}</TableCell>
                      <TableCell align="right">{row.AedTerm}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </GlobalWrapper>
      ) : null}
    </Box>
  );
};

export default TestCourse;
